(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class RelativeHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this;
    this.dropdowns = this.querySelectorAll("details.site-header__label");
    this.setupListener();
  }

  setupListener() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.querySelector("summary").addEventListener('click', this.updateActiveDialog.bind(this));
    });
  }

  updateActiveDialog(e) {
    let thisDropdown = e.target.parentNode;

    // Close all other dropdowns
    this.dropdowns.forEach((dropdown) => {
      if (dropdown !== thisDropdown) {
        dropdown.removeAttribute("open");
      }
    });

    // Toggle header class based on dropdown state
    if (thisDropdown.hasAttribute("open")) {
      if (!thisDropdown.classList.contains('__scroll')) {
        document.body.classList.remove('__mobile-overflow-none');
      }
      this.header.classList.remove('__dropdown-open');
    } else {
      if (!thisDropdown.classList.contains('__scroll')) {
        document.body.classList.add('__mobile-overflow-none');
      }
      this.header.classList.add('__dropdown-open');
    }
  }
}

customElements.define('relative-header', RelativeHeader);

class StickyHeader extends RelativeHeader {
  constructor() {
    super();
    this.lastScrollTop = 0; // Initialize last scroll position
    document.addEventListener('scroll', this.updateClass.bind(this));
  }

  updateClass() {
    let currentScrollTop = window.pageYOffset;
    let alwaysShowNav = this.classList.contains('__always-show-nav');
    let scrollingDown = currentScrollTop > this.lastScrollTop;

    // Update last scroll position
    this.lastScrollTop = currentScrollTop;

    // Add or remove the `__hidden` class based on scroll direction
    if (scrollingDown && !alwaysShowNav && currentScrollTop > 0 && window.innerWidth >= 1200) {
      this.classList.add('__hidden');
    } else {
      this.classList.remove('__hidden');
    }

    // Ensure the header is always in the correct state
 
    if(currentScrollTop <=200 && !scrollingDown){
      this.classList.add('__relative');
    }
   else if (currentScrollTop <= 0) {
      this.classList.add('__relative');
    } else {
      this.classList.remove('__relative');
    }
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soliege-feedback"] && !Shopify.designMode) return;
  try {
    

function initSoliegeFeedback(){
 const root=document.getElementById('sf-feedback');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('form');if(!form||!root.querySelector('#sf-email'))return;
 const email=root.querySelector('#sf-email');const link=window.soliegeFeedbackLink||{};delete window.soliegeFeedbackLink;
 if(!email.value&&typeof link.email==='string'&&link.email.length<=254&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(link.email))email.value=link.email;
 const allowed=['tested','notyet','help'];if(allowed.includes(link.state)){const option=form.querySelector('input[name="contact[status]"][value="'+link.state+'"]');if(option)option.checked=true;}
 const tested=root.querySelector('#sf-tested');
 function update(){const checked=form.querySelector('input[name="contact[status]"]:checked');const show=checked&&checked.value==='tested';tested.hidden=!show;tested.querySelectorAll('input').forEach(input=>{input.disabled=!show;});}
 form.querySelectorAll('input[name="contact[status]"]').forEach(input=>input.addEventListener('change',update));update();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initSoliegeFeedback);}else{initSoliegeFeedback();}
document.addEventListener('shopify:section:load',initSoliegeFeedback);


  } catch(e) { console.error(e); }
})();
})();
